import { rolesConstants } from "redux/constants/roles.constants";

export function updateRolesReducer(state = {}, action) {
  switch (action.type) {
    case rolesConstants.UPDATE_ROLES_REQUEST:
      return { loading: true };
    case rolesConstants.UPDATE_ROLES_SUCCESS:
      return { roles: action.payload.data };
    case rolesConstants.UPDATE_ROLES_FAILURE:
      return { loading: true };
    default:
      return state;
  }
}
